import logo from "../../assets/logo-redondo.png"

function AniverCard(props){

const logoAlter="https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/colaboradores%2Ffoto_aniver%2Faniver_padrao.jpg?alt=media&token=e8c4419a-0d2b-4c0c-ac7c-0926bd8b848f"
   
return (
      <>
        <div className="card  shadow-sm ">
          <div className="card-body d-flex flex-column align-items-center p-3">
            <div className="logo-container mb-3">
              <img src={props.img || logoAlter} alt="logo" className="img-fluid rounded-circle" />
            </div>
            <h5 className="card-title text-center fw-bold">{props.nome}</h5>
            <div className="card-text text-center">           
              <p className="text-muted small">
                <i className="bi bi-calendar me-1"></i>
                {props.data}
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };
  export default AniverCard